/* <template>
    <div class="l-section l-section--main o-checkout">
        <div
            class="l-container l-container--main o-checkout__mainContainer"
            v-if="customer"
        >
            <div class="l-row o-checkout__columns">
                <div class="l-row__column l-row__column--8">
                    <div class="o-checkout__content a-mobile">
                        <div class="l-row l-row--wrap">
                            <div class="l-row__column l-row__column--12">
                                <h2 class="a-title">Szczegóły dostawy</h2>
                            </div>
                            <div class="l-row__column l-row__column--12">
                                <m-accordion
                                    v-for="(address, addressIdx) in customerAddresses"
                                    :title="address.address"
                                    v-bind:key="addressIdx"
                                    :visible="addressVisible[addressIdx]"
                                    :ref="`address-${addressIdx}`"
                                >
                                    <template v-if="!address.warehouse.external_supplier">
                                        <o-notifications
                                            :is-static="true"
                                            :name="`control-address${addressIdx}-delivery`"
                                        />
                                        <label class="a-label a-control__label">
                                            Godziny dostaw
                                        </label>
                                        <select
                                            class="a-select"
                                            :value="deliveryHoursIds[addressIdx]"
                                            @input="setDeliveryHoursId(addressIdx, $event.target.value)"
                                            :name="`control-deliveryHours${deliveryHoursIds[addressIdx]}`"
                                            :id="`control-deliveryHours${deliveryHoursIds[addressIdx]}`"
                                        >
                                            <option value="-1">-- wybierz opcję --</option>
                                            <option
                                                v-for="deliveryHour in deliveryHours"
                                                v-bind:key="deliveryHour.id"
                                                :value="deliveryHour.id"
                                            >{{ deliveryHour.name }} ({{ deliveryHour.remarks }})</option>
                                        </select>
                                    </template>
                                    <div class="l-row l-row--nested l-row--wrap">
                                        <div class="l-row__column l-row__column--12">
                                            <a-control
                                                label="Uwagi dla dostawcy"
                                                placeholder="Wpisz"
                                                :value="address.remarks"
                                                @input="setCustomerAddressField(addressIdx, 'remarks', $event)"
                                                :id="`control-address${addressIdx}remarks`"
                                                type="textarea"
                                                rows="4"
                                            />
                                        </div>
                                        <template v-if="address.geometry && address.geometry.lat && address.geometry.lng">
                                            <GmapMap
                                                class="a-control__map"
                                                :center="address.geometry"
                                                :zoom="15"
                                                map-type-id="terrain"
                                                ref="gmap"
                                            >
                                                <GmapMarker
                                                    :position="address.geometry"
                                                    :clickable="true"
                                                    :draggable="true"
                                                    @dragend="updateCoordinates($event, addressIdx)"
                                                />
                                            </GmapMap>
                                        </template>
                                    </div>
                                </m-accordion>
                            </div>
                            <div
                                class="l-row__column l-row__column--12"
                                ref="payment"
                            >
                                <div
                                    v-if="beforeCheckoutMessage"
                                    class="o-notifications o-notifications--static o-checkout__notification"
                                >
                                    <article
                                        class="o-notifications__notification o-notifications__notification--success"
                                    >
                                        <div class="o-notifications__notificationBody">
                                            <p class="o-checkout__notificationText">
                                                {{ beforeCheckoutMessage }}
                                            </p>
                                        </div>
                                    </article>
                                </div>
                                <o-notifications
                                    :is-static="true"
                                    name="control-payment"
                                />
                                <div
                                    v-for="paymentMethod in paymentMethods"
                                    v-bind:key="paymentMethod.symbol"
                                >
                                    <template
                                        v-if="paymentMethod.symbol === 'card'"
                                    >
                                        <br /><br />
                                        <h2 class="a-title">Zamów abonament</h2>
                                    </template>
                                    <template
                                        v-if="paymentMethod.symbol === 'transfer'"
                                    >
                                        <br /><br />
                                        <h2 class="a-title">Zamów na próbę</h2>
                                    </template>
                                    <a-control
                                        class="a-control--hasPaddings"
                                        :id="paymentMethod.symbol"
                                        type="radio"
                                        name="paymentMethods"
                                        :value="paymentMethod.symbol"
                                        @input="paymentSymbol = $event"
                                    >
                                        <div v-if="paymentMethod.symbol === 'transfer'">
                                            <svg class="o-checkout__paymentIcon" width="77" height="39" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M76.089 8.015h-3.397a.657.657 0 01-.664-.664v-3.45c0-.371.292-.663.664-.663h3.397c.371 0 .663.292.663.663v3.45a.657.657 0 01-.663.664zM71.577 3.238h-2.309a.465.465 0 01-.451-.451V.45c0-.239.212-.451.451-.451h2.309c.239 0 .451.212.451.451v2.336a.465.465 0 01-.451.45z" fill="#A6C307"/><path d="M8.758 9.554H3.822C1.194 9.554 0 10.722 0 13.376v16.959c0 1.008.318 1.353 1.354 1.353h.345c1.008 0 1.353-.318 1.353-1.354v-6.581h5.733c5.095 0 7.457-2.256 7.457-7.086-.026-4.884-2.388-7.113-7.484-7.113zm4.432 7.086c0 2.76-.716 4.247-4.432 4.247H3.026v-7.14c0-.982.371-1.353 1.353-1.353h4.379c2.813 0 4.432.69 4.432 4.246zm9.395-2.23c-1.964 0-3.185.24-3.636.346-.823.186-1.168.398-1.168 1.353v.266c0 .371.053.61.16.796.132.212.345.318.637.318.132 0 .318-.026.504-.08a18.44 18.44 0 013.61-.37c2.945 0 4.166.822 4.166 2.812v1.779h-3.716c-4.777 0-7.006 1.619-7.006 5.095 0 3.37 2.309 5.228 6.476 5.228 4.963 0 7.192-1.698 7.192-5.493V19.85c0-3.662-2.362-5.44-7.219-5.44zm4.273 9.635v2.335c0 1.885-.69 3-4.3 3-2.361 0-3.53-.85-3.53-2.628 0-1.938 1.169-2.68 4.114-2.68h3.716v-.027zm19.374-7.803l-3.848 15.34c-1.115 4.512-3.053 6.422-6.635 6.661h-.266c-.77 0-1.008-.424-1.167-1.114l-.053-.292c-.054-.319-.107-.664.08-.903.185-.238.503-.318.981-.345 2.415-.239 3.211-1.353 4.008-3.874-.372.132-.823.185-1.328.185-2.627 0-3.343-1.83-3.954-4.06L30.92 16.269c-.107-.398-.186-.797.026-1.062s.61-.318 1.008-.318h.266c1.008 0 1.38.292 1.645 1.247l3.132 11.518c.398 1.433.823 1.672 1.831 1.672.823 0 1.327-.265 1.672-1.672l2.76-11.518c.213-.955.61-1.274 1.62-1.274h.291c.398 0 .796.027 1.009.292.212.318.159.716.053 1.088zm22.558-4.485V23.408c0 1.884-.424 3.45-1.247 4.724-1.566 2.468-4.618 3.795-8.97 3.795h-.053c-4.353 0-7.405-1.327-8.97-3.795-.823-1.274-1.248-2.867-1.248-4.724V11.757c0-1.884.77-2.23 2.84-2.23h.636c2.07 0 2.84.346 2.84 2.23v11.651c0 .743.133 1.353.451 1.804.558.876 1.672 1.248 3.45 1.274 1.779 0 2.893-.398 3.45-1.274.293-.477.452-1.061.452-1.804V17.25v-5.494c0-1.884.77-2.23 2.84-2.23h.637c2.123.027 2.892.372 2.892 2.23z" fill="url(#paint0_linear)"/><path d="M71.126 14.437H66.56a.895.895 0 01-.902-.902V8.917c0-.504.398-.902.902-.902h4.565c.504 0 .902.398.902.902v4.618a.895.895 0 01-.902.902z" fill="#A6C307"/><defs><linearGradient id="paint0_linear" x1="34.401" y1="42.012" x2="34.401" y2="10.027" gradientUnits="userSpaceOnUse"><stop stop-color="#438F29"/><stop offset=".705" stop-color="#A6C307"/></linearGradient></defs></svg>
                                        </div>
                                        <div v-if="paymentMethod.symbol === 'subscription'">
                                            <svg class="o-checkout__paymentIcon" width="65" height="49" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x=".8" y=".8" width="52.4" height="33.5" rx="5.2" stroke="#737373" stroke-width="1.6"/><path stroke="#737373" stroke-width="1.6" d="M.8 8.9h52.4v6.5H.8z"/><path fill="#737373" d="M7.2 21.6h23.4v1.6H7.2zM7.2 27.9h18v1.6h-18z"/><circle cx="51" cy="35" r="13.2" fill="#fff" stroke="#737373" stroke-width="1.6"/><rect x="43.825" y="29.8" width="14.4" height="12.4" rx="1.2" stroke="#737373" stroke-width="1.6"/><mask id="a" fill="#fff"><path d="M46.025 28a1 1 0 011-1h2a1 1 0 011 1v2h-4v-2z"/></mask><path d="M46.025 28a1 1 0 011-1h2a1 1 0 011 1v2h-4v-2z" stroke="#737373" stroke-width="3" mask="url(#a)"/><mask id="b" fill="#fff"><path d="M52.025 28a1 1 0 011-1h2a1 1 0 011 1v2h-4v-2z"/></mask><path d="M52.025 28a1 1 0 011-1h2a1 1 0 011 1v2h-4v-2z" stroke="#737373" stroke-width="3" mask="url(#b)"/><path stroke="#737373" stroke-width="1.6" d="M43.025 33.2h12"/></svg>
                                        </div>
                                        <div v-if="paymentMethod.symbol === 'card'">
                                            <svg class="o-checkout__paymentIcon" width="65" height="49" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x=".8" y=".8" width="52.4" height="33.5" rx="5.2" stroke="#737373" stroke-width="1.6"/><path stroke="#737373" stroke-width="1.6" d="M.8 8.9h52.4v6.5H.8z"/><path fill="#737373" d="M7.2 21.6h23.4v1.6H7.2zM7.2 27.9h18v1.6h-18z"/><circle cx="51" cy="35" r="13.2" fill="#fff" stroke="#737373" stroke-width="1.6"/><mask id="a" fill="#fff"><path fill-rule="evenodd" clip-rule="evenodd" d="M47.5 27a1.5 1.5 0 00-1.5 1.5V31a5 5 0 002.818 4.5A5 5 0 0046 40v2.5a1.5 1.5 0 001.5 1.5h7a1.5 1.5 0 001.5-1.5V40a5 5 0 00-2.818-4.5A5 5 0 0056 31v-2.5a1.5 1.5 0 00-1.5-1.5h-7z"/></mask><path d="M48.818 35.5l.437.9 1.851-.9-1.851-.9-.437.9zm4.364 0l-.437-.9-1.851.9 1.851.9.437-.9zM47 28.5a.5.5 0 01.5-.5v-2a2.5 2.5 0 00-2.5 2.5h2zm0 2.5v-2.5h-2V31h2zm2.255 3.6A4 4 0 0147 31h-2a6 6 0 003.381 5.4l.874-1.8zm-.874 0A6 6 0 0045 40h2a4 4 0 012.255-3.6l-.874-1.8zM45 40v2.5h2V40h-2zm0 2.5a2.5 2.5 0 002.5 2.5v-2a.5.5 0 01-.5-.5h-2zm2.5 2.5h7v-2h-7v2zm7 0a2.5 2.5 0 002.5-2.5h-2a.5.5 0 01-.5.5v2zm2.5-2.5V40h-2v2.5h2zm0-2.5a6 6 0 00-3.381-5.4l-.874 1.8A4 4 0 0155 40h2zm-2-9a4 4 0 01-2.255 3.6l.874 1.8A6 6 0 0057 31h-2zm0-2.5V31h2v-2.5h-2zm-.5-.5a.5.5 0 01.5.5h2a2.5 2.5 0 00-2.5-2.5v2zm-7 0h7v-2h-7v2z" fill="#737373" mask="url(#a)"/><rect x="45.5" y="26.5" width="11" height="1" rx=".5" fill="#fff" stroke="#737373"/><rect x="45.5" y="43.5" width="11" height="1" rx=".5" fill="#fff" stroke="#737373"/></svg>
                                        </div>
                                        <div>
                                            <p><span>{{ paymentMethod.name }}</span></p>
                                            <p>
                                                {{ paymentMethod.description }}
                                            </p>
                                        </div>
                                    </a-control>
                                </div>
                            </div>
                            <div class="l-row__column l-row__column--12">
                                <a-control
                                    v-for="(term, termIdx) in terms"
                                    v-bind:key="term.symbol"
                                    type="checkbox"
                                    class="a-control--hasPaddings"
                                    :id="`control-terms-${term.symbol}`"
                                    @input="termClick($event, termIdx)"
                                    :value="acceptedTerms[termIdx]"
                                    :ref="`terms-${term.symbol}`"
                                >
                                    <p v-html="term.description"></p>
                                </a-control>
                            </div>
                            <div class="l-row__column l-row__column--12 o-checkout__buttons a-mobile__buttons">
                                <button
                                    class="a-button a-mobile__button"
                                    @click="backToCart"
                                >
                                    Powrót do koszyka
                                </button>
                                <a-button
                                    type="submit"
                                    class="a-button a-button--secondary a-mobile__button"
                                    @click="handleSubmit"
                                    :is-processing="orderStatus !== 'idle'"
                                    :disabled="orderStatus !== 'idle'"
                                >
                                    Zamawiam
                                    <svg class="a-button__icon" width="6" height="8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.625 7l3.328-2.958-3.328-2.959" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                                </a-button>
                                <form
                                    :action="orderPaymentUrl"
                                    method="post"
                                    class="o-checkout__paymentForm"
                                >
                                    <input
                                        type="hidden"
                                        name="additionalParams[slug]"
                                        :value="orderSlug"
                                    >
                                    <input
                                        type="hidden"
                                        name="additionalParams[direct]"
                                        :value="paymentSymbol === 'transfer' ? 1 : 0"
                                    >
                                    <input
                                        type="hidden"
                                        name="continueUrl"
                                        :value="orderContinueUrl"
                                    >
                                    <button
                                        id="pay-button"
                                        type="submit"
                                        name="button"
                                    ></button>
                                </form>
                            </div>
                        </div>
                        <o-notifications
                            :is-static="true"
                            name="control-summary"
                        />
                    </div>
                </div>
                <div class="l-row__column l-row__column--4 o-checkout__summary">
                    <checkout-summary />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CheckoutSummary from '@/components/CheckoutSummary'
import MAccordion from '@/components/MAccordion'
import { gmapApi } from 'gmap-vue'
export default {
    metaInfo: {
        title: 'Podsumowanie'
    },
    components: {
        CheckoutSummary,
        MAccordion
    },
    data() {
        return {
            paymentSymbol: '',
            acceptedTerms: [],
            addressVisible: [],
            deliveryHoursIds: []
        }
    },
    computed: {
        google: gmapApi,
        customer() {
            return this.$store.getters.customer
        },
        customerAddresses() {
            return this.$store.getters.customerAddresses
        },
        terms() {
            return this.$store.getters.terms
        },
        paymentMethods() {
            const payments = []
            const transfer = this.$store.getters.paymentMethods.findIndex(item => item.symbol === 'transfer')
            if(transfer !== -1) {
                payments.push(this.$store.getters.paymentMethods[transfer])
            }
            const card = this.$store.getters.paymentMethods.findIndex(item => item.symbol === 'card')
            if(card !== -1) {
                payments.push(this.$store.getters.paymentMethods[card])
            }
            const subscription = this.$store.getters.paymentMethods.findIndex(item => item.symbol === 'subscription')
            if(subscription !== -1) {
                payments.push(this.$store.getters.paymentMethods[subscription])
            }
            return payments
        },
        orderStatus() {
            return this.$store.getters.orderStatus
        },
        einvoiceRemarks: {
            get() { return this.$store.getters.customer.einvoiceRemarks },
            set(value) { this.$store.dispatch('setCustomerField', { field: 'einvoiceRemarks', value }) }
        },
        orderPaymentUrl() {
            return this.$store.getters.orderPaymentUrl
        },
        orderSlug() {
            return this.$store.getters.orderSlug
        },
        orderContinueUrl() {
            return `${window.location.origin}${this.$router.resolve({ name: 'thank-you' }).href}`
        },
        deliveryHours() {
            return this.$store.getters.deliveryHours
        },
        beforeCheckoutMessage() {
            return this.$store.getters.beforeCheckoutMessage
        }
    },
    methods: {
        backToCart() {
            this.$store.dispatch('resetOrderStatus')
            this.$router.push({ name: 'cart' })
        },
        termClick($event, termIdx) {
            if(this.acceptedTerms[termIdx] !== true) {
                this.$set(this.acceptedTerms, termIdx, true)
            } else {
                this.$set(this.acceptedTerms, termIdx, false)
            }
        },
        updateCoordinates(location, addressId) {
            this.$store.dispatch('setCustomerAddressField', {
                addressId,
                field: 'geometry',
                value: {
                    lat: location.latLng.lat(),
                    lng: location.latLng.lng()
                }
            })
        },
        setCustomerAddressField(addressId, field, value) {
            this.$store.dispatch('setCustomerAddressField', {
                addressId,
                field,
                value
            })
        },
        handleSubmit() {
            // validate payment
            if(this.paymentSymbol === '') {
                this.$scrollTo(this.$refs.payment, 500, {
                    offset: -65
                })
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Wybierz rodzaj płatności',
                    limit: 0,
                    name: 'control-payment'
                })
                return false
            }
            // validate terms
            let valid = true
            this.terms.forEach((term, idx) => {
                if(this.acceptedTerms[idx] === undefined || this.acceptedTerms[idx] === false) {
                    this.$scrollTo(this.$refs[`terms-${term.symbol}`][0].$el, 500, {
                        offset: -65
                    })
                    this.$store.dispatch('addNotification', {
                        type: 'danger',
                        content: 'Musisz zaakceptowć warunki.',
                        limit: 0,
                        name: `control-terms-${term.symbol}`
                    })
                    valid = false
                    return false
                }
            })
            if(!valid) {
                return false
            }
            // agregate payload
            const store = this.$store.getters
            const minimumValuesString = Object.values(store.minimumValue).join(',')
            const payload = {
                invoice: {
                    remarks: this.einvoiceRemarks
                },
                payment: {
                    symbol: this.paymentSymbol
                },
                deliveries: [],
                settings: {
                    logistic_minimum: minimumValuesString
                },
                terms: []
            }
            const addresses = []
            for(const idx in this.$store.getters.customerAddresses) {
                const address = this.$store.getters.customerAddresses[idx]
                const packages = this.$store.getters.weekOrders.filter(order => order.addressId === +idx).map(order => {
                    return {
                        id: order.product.id,
                        amount: order.amount,
                        unit_price: this.$store.getters.packagePrice(order.product.id, order.dayInWeek, order.addressId),
                        isodow: order.dayInWeek + 1,
                        date_from: this.$store.getters.customerAddress(idx).dateFrom,
                        checksum: order.product.checksum
                    }
                })
                const newAddress = {
                    city: address.city,
                    postcode: address.postcode,
                    address: `${address.street} ${address.number}`,
                    address_contact: address.contactPerson,
                    hour_from: address.hoursFrom,
                    hour_to: address.hoursTo,
                    earliest_from: address.earliestFrom,
                    remarks: address.remarks,
                    week_price: this.$store.getters.weekAmount(+idx),
                    latitude: address.geometry.lat,
                    longitude: address.geometry.lng,
                    warehouse_id: address.warehouse.id,
                    external: address.warehouse.external_supplier ? 1 : 0,
                    company_size: +address.companySize,
                    packages: []
                }
                // add client_detail_id aka addressExternalId when is present (removes the need to have company object)
                if (address.addressExternalId) {
                    Object.assign(newAddress, {
                        client_detail_id: address.addressExternalId
                    })
                }
                this.$set(newAddress, 'packages', packages)
                addresses.push(newAddress)
            }
            this.$set(payload, 'deliveries', addresses)
            // terms
            const terms = []
            this.terms.forEach((term, idx) => {
                terms.push({
                    symbol: term.symbol,
                    confirmed: this.acceptedTerms[idx] !== undefined && this.acceptedTerms[idx] !== false
                })
            })
            this.$set(payload, 'terms', terms)
            this.$store.dispatch('submitOrder', payload).then(() => {
            }).catch(error => {
                this.$store.dispatch('resetOrderStatus')
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: `Wystąpił nieoczekiwany błąd:<br />${error}`,
                    limit: 0,
                    name: 'control-summary',
                    dontRemove: true
                })
            })
        },
        setDeliveryHoursId(addressIdx, value) {
            this.$set(this.deliveryHoursIds, addressIdx, value)
            let hoursFrom = ''
            let hoursTo = ''
            if(+value !== -1) {
                hoursFrom = this.deliveryHours.find(item => +item.id === +value).hour_from
                hoursTo = this.deliveryHours.find(item => +item.id === +value).hour_to
            }
            this.setCustomerAddressField(addressIdx, 'hoursFrom', hoursFrom)
            this.setCustomerAddressField(addressIdx, 'hoursTo', hoursTo)
            this.setCustomerAddressField(addressIdx, 'earliestFrom', hoursFrom)
        }
    },
    mounted() {
        this.$store.dispatch('fetchTerms')
        this.$store.dispatch('fetchPaymentMethods')
        this.$store.dispatch('fetchDeliveryHours').then(() => {
            for(const addressIdx in this.customerAddresses) {
                if(this.deliveryHours[0] !== undefined) {
                    this.$set(this.deliveryHoursIds, addressIdx, -1)
                }
            }
        })
    }
}
</script>
